import {
    ChangeDetectionStrategy,
    Component,
    computed,
    Inject,
    inject,
    ViewEncapsulation,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import {
    ClickmeDialogRef,
    CLICKME_DIALOG_DATA,
} from '@clickme/angular';
import {
    ContactUpdateErrorTypeSelector,
    ResetContactUpdateAction,
    VerifyMobilePhoneAction,
} from './../../../../core';
import { RoseOtpEntryViewComponent } from '../otp-entry-view/otp-entry-view.component';

export interface OtpEntryDialogData {
    verificationId: string;
    destinationMasked: string;
}

@Component({
    selector: 'rose-portal-otp-entry-modal',
    standalone: true,
    imports: [
        TranslateModule,
        RoseOtpEntryViewComponent,
    ],
    templateUrl: './otp-entry-modal.component.html',
    styleUrl: './otp-entry-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class OtpEntryModalComponent {
    readonly #store = inject(Store);
    readonly #dialogRef = inject(ClickmeDialogRef);

    readonly #verificationId: string;
    readonly destinationMasked: string;

    readonly errorType = this.#store.selectSignal(ContactUpdateErrorTypeSelector);
    readonly hasError = computed(() => this.errorType() === 'invalid_otp');

    constructor(
        @Inject(CLICKME_DIALOG_DATA) data: OtpEntryDialogData,
    ) {
        this.#verificationId = data.verificationId;
        this.destinationMasked = data.destinationMasked;
    }

    onCodeEntered(otpCode: string): void {
        this.#store.dispatch(VerifyMobilePhoneAction({
            verificationId: this.#verificationId,
            otpCode,
        }));
    }

    onGoBack(): void {
        this.#store.dispatch(ResetContactUpdateAction());
        this.#dialogRef.close();
    }
}
